// extracted by mini-css-extract-plugin
export var cta = "Hero-module--cta--2oAv+";
export var img = "Hero-module--img--tpSVy";
export var root = "Hero-module--root--zhgG9";
export var txt = "Hero-module--txt--2Qa3L";